/* prettier-ignore */

import { inject, Injectable } from '@angular/core';
import { NewCustomRouteService } from 'src/app/pages/new-custom-route/new-custom-route.service';
import { ModalController } from '@ionic/angular';
import { isNotSuccess, validateRoute } from './guards/custom-route.guard';
import { of } from 'rxjs';

type Result = { is_successful: true, content?: string } | { is_successful: false; reason: string };

@Injectable({ providedIn: 'root' })

export class GetFreeSlotsService {
    private _modalController = inject(ModalController);
    private _customRouteService = inject(NewCustomRouteService);

    public getAvailableItemsOnSlot(args: any){
        this._modalController?.dismiss().catch(e => {
            console.warn("No modal found on dismiss")
        });

        const route = this._customRouteService.route();
        const ctx = validateRoute(route, args?.day);
        if (isNotSuccess(ctx)){
            return of<Result>(ctx);
        }

        const { indexDay, indexPoint } = this._customRouteService.getItemPositionFromTimeline(args);
        const result = this._customRouteService.getItemsAvailables(indexDay, indexPoint);
        switch (result){
            case 'Busy slot': return of<Result>({ is_successful: false, reason: result });
            case 'No available items': return of<Result>({ is_successful: false, reason: result });
            default: return of<Result>({ is_successful: true, content: result });
        }
    }

}